module.exports = __webpack_public_path__ + "static/media/classics-2-1.61828dc7.jpg";